<template>
<div>
    <div class="tabs-header">
        <div
            :class="['tabs-header-item', { active: active_tab === 'facility' }]"
            @click="active_tab = 'facility'">
            By Facility
        </div>
        <!-- <div
            :class="['tabs-header-item', { active: active_tab === 'state' }]"
            @click="active_tab = 'state'">
            By State
        </div> -->
    </div>

    <div class="tabs-content" style="z-index: 2;">
        <div v-if="active_tab === 'facility'">
            <find-facility-card
                @loading="is_loading_facility = true"
                @loaded="is_loading_facility = false"
                @change="onChangeFacility"
                @error="onFindFacilityError"></find-facility-card>

            <p v-if="findFacilityError.length !== 0" class="danger-text mt-3">{{ findFacilityError }}</p>
        </div>

        <div v-else>
            <card class="flex" :toggleable="true">
                <template slot="header">
                    <i class="material-icons">search</i>
                    <strong class="ml-2">Select a state</strong>
                </template>

                <template slot="body">
                    <select-input
                        :active-index="active_state_index"
                        :choices="state_options"
                        :fixed="true"
                        @change="onChangeState"></select-input>
                </template>
            </card>
        </div>
    </div>

    <div class="flex mt-3">
        <loading-wrapper class="flex-a" :loading="is_loading_tenants">
            <card>
                <template slot="header">
                    <div class="flex jc-sb">
                        <div>
                            <i class="material-icons">mail</i>
                            <strong class="d-ib ml-2">Tenants</strong>
                        </div>
                    </div>
                </template>

                <template slot="body">
                    <div class="flex ai-c">
                        <select-input
                            :active-index="active_filter_index"
                            :choices="filter_options"
                            :disabled="!filter_counts"
                            @change="(index) => active_filter_index = index"></select-input>

                        <button class="ml-3 danger" type="button"
                            @click="show_remove_ineligible_tenants_modal = true"
                            :disabled="is_loading_letters"
                            v-tooltip.left="'Automatically remove tenants who are ineligible to begin the ALP process. \
                                            This can also be manually done by flagging and deleting tenants from the Tenant List page.'"
                            >Remove Ineligible Tenants</button>
                        <button class="ml-3" type="button"
                            @click="sync_ledger_statuses"
                            :disabled="is_loading_letters"
                            v-tooltip.left="'Automatically update the status of tenants undergoing the ALP process.\
                                            This can also be manually done from the Tenant List page.'"
                            >Sync Tenant Statuses</button>
                    </div>

                    <div class="flex ai-c mt-3 mb-3">
                        <div class="flex-0 ws-nw">
                            <span v-if="checked_tenants.length === 0">Download up to 300 Letters</span>
                            <span v-else>Download {{ checked_tenants.length.toLocaleString() }} Letter<span v-show="checked_tenants.length !== 1">s</span></span>
                             for:
                        </div>

                        <div>
                            <button class="ml-3" type="button"
                                :disabled="is_loading_letters || has_tagged_tenants"
                                @click="displayLetterWarningModal(LETTER_TYPES.initial)">Audit Letter</button>

                            <button class="ml-3" type="button"
                                :disabled="is_loading_letters || has_tagged_tenants"
                                @click="displayLetterWarningModal(LETTER_TYPES.reminder)">Reminder Letter</button>

                            <button class="ml-3" type="button"
                                :disabled="is_loading_letters || has_tagged_tenants"
                                @click="displayLetterWarningModal(LETTER_TYPES.welcome)">Welcome Letter</button>
                        </div>

                        <div v-if="active_tab === 'facility'" class="flex ai-c">
                            <span class="hint ml-2 mr-2">|</span>

                            <button type="button"
                                :disabled="is_loading_letters || !facility"
                                @click="generateSampleLetters">Sample Letters</button>
                        </div>

                        <div v-show="is_loading_letters" class="flex ai-c ml-2">
                            <img src="../../assets/img/loading-black-32.gif" alt="loading" />
                        </div>
                    </div>

                    <div class="badge warning mt-1">
                        <i class="material-icons">warning</i>
                        <span>Only tenants <strong>without</strong> an email set will receive a welcome letter.</span>
                    </div>

                    <div v-show="has_tagged_tenants" class="mt-3 mb-3">
                        <span class="badge warning"><i class="material-icons">warning</i> Warning</span>
                        <span class="ml-1">Some tenants are tagged for removal. They will need to be removed or untagged before continuing.</span>
                    </div>

                    <div v-if="data_info && data_info.incomplete_address > 0" class="danger-text flex ai-c mt-3 mb-3">
                        <span class="mr-2"><i class="material-icons">announcement</i></span>

                        <span v-if="data_info.incomplete_address === 1">1 tenant is hidden because it has an incomplete address!</span>
                        <span v-else>{{ data_info.incomplete_address.toLocaleString() }} tenants are hidden because they have an incomplete address!</span>
                    </div>

                    <div v-show="download_initiated" class="hint mt-3 mb-3">If no download box has appeared, please disable your popup-blocker for this site.</div>

                    <div class="flex ai-c jc-sb mt-3">
                        <div>
                            &nbsp;
                        </div>

                        <div class="ta-c">
                            <div class="o-a">
                                <vue-table-pagination
                                    ref="tenants_table_pagination"
                                    @vuetable-pagination:change-page="onChangePage">
                                </vue-table-pagination>
                            </div>

                            <div class="fs-09 mt-2">
                                <vue-table-pagination-info ref="tenants_table_info"
                                    info-template="{total} total tenants"
                                    no-data-template="" />

                                <div v-if="filter_counts" class="gray-message">
                                    ({{ filter_counts.welcome_letter_skipped }} Bader tenants won&rsquo;t be getting welcome letters)
                                </div>
                            </div>
                        </div>

                        <div>
                            <button type="button" :disabled="(active_tab === 'facility' && !facility) || (active_tab === 'state' && !active_state) || is_loading_tenants" @click="reloadTable">
                                <i class="material-icons">refresh</i>
                            </button>
                        </div>
                    </div>

                    <div class="mt-5">
                        <vue-table ref="tenants_table"
                            :load-on-start="false"
                            :append-params="table_api_params"
                            :api-url="table_api_url"
                            :api-mode="(table_api_url) ? true : false"
                            data-path="data.data"
                            pagination-path="data.pagination"
                            :http-options="http_options"
                            :fields="columns"
                            :per-page="100"
                            table-height="475px"
                            @vuetable:loading="onTableLoadStart"
                            @vuetable:loaded="is_loading_tenants = false"
                            @vuetable:load-success="onTableLoadSuccess"
                            @vuetable:pagination-data="onPaginationData"
                            @vuetable:row-clicked="onRowClicked"
                            no-data-template="<span>No tenants to show.</span>">
                            <template slot="checkbox" slot-scope="props">
                                <checkbox
                                    :alone="true"
                                    :center="true"
                                    :checked="checked_tenants.indexOf(props.rowData.id) !== -1"
                                    @click="toggleCheckbox(props.rowData.id)"></checkbox>
                            </template>

                            <template slot="name" slot-scope="props">
                                <div class="flex jc-sb">
                                    <span
                                        v-if="props.rowData.last_name !== null"
                                        class="row-name"
                                        :title="`${props.rowData.last_name}, ${props.rowData.first_name}`">
                                        {{ props.rowData.last_name }}, {{ props.rowData.first_name }}
                                    </span>
                                    <span
                                        v-else
                                        class="row-name"
                                        :title="props.rowData.first_name">
                                        {{ props.rowData.first_name }}
                                    </span>

                                    <span
                                        v-show="props.rowData.tagged_for_removal"
                                        class="as-c"
                                        title="Flagged for deletion">
                                        <i class="danger-text material-icons">flag</i>
                                    </span>
                                </div>
                            </template>

                            <template slot="cycle_label" slot-scope="props">
                                <span class="badge">{{ props.rowData.cycle_label }}</span>
                            </template>

                            <template slot="facility_number" slot-scope="props">
                                <div class="flex jc-sb">
                                    {{ props.rowData.facility_number }}
                                </div>
                            </template>

                            <template slot="initial_letter_sent" slot-scope="props">
                                <span class="success-text" v-if="props.rowData.initial_letter_sent_date !== null">
                                    <i class="material-icons">check_circle</i>
                                </span>
                            </template>

                            <template slot="reminder_letter_sent" slot-scope="props">
                                <span class="success-text" v-if="props.rowData.reminder_letter_sent_date !== null">
                                    <i class="material-icons">check_circle</i>
                                </span>
                            </template>

                            <template slot="welcome_letter_sent" slot-scope="props">
                                <span class="success-text" v-if="props.rowData.welcome_letter_sent_date !== null">
                                    <i class="material-icons">check_circle</i>
                                </span>
                            </template>
                        </vue-table>
                    </div>
                </template>
            </card>
        </loading-wrapper>
    </div>

    <modal v-show="show_tenant_length_modal" @close="show_tenant_length_modal = false">
        <template slot="header">
            Alert
        </template>

        <template slot="content">
            In an effort to conserve system resources, only 300 tenants may be selected at a time. If you need to download letters for more tenants, then you will need to download the letters in batches of 300.
        </template>

        <template slot="footer">
            <div class="flex jc-fe">
                <button type="button" @click="show_tenant_length_modal = false">Ok</button>
            </div>
        </template>
    </modal>

    <modal v-show="success_modal_data.show" @close="success_modal_data.show = false">
        <template slot="header">
            Success!
        </template>

        <template slot="content">
            <span v-show="success_modal_data.letter_type === LETTER_TYPES.initial">Audit</span>
            <span v-show="success_modal_data.letter_type === LETTER_TYPES.reminder">Reminder</span>
            <span v-show="success_modal_data.letter_type === LETTER_TYPES.welcome">Welcome</span>
            <span v-show="success_modal_data.letter_type === LETTER_TYPES.sample">Sample</span>
            <span>letters have been successfully generated for {{ success_modal_data.tenant_count }} tenants.</span>
        </template>

        <template slot="footer">
            <div class="flex jc-fe">
                <div v-if="success_modal_data.mail_merge_url  !== null" class="mr-3">
                    <a class="button" :href="success_modal_data.mail_merge_url" target="_blank">Mail Merge</a>
                </div>

                <a class="button" :href="success_modal_data.url" target="_blank">Download</a>
            </div>
        </template>
    </modal>

    <modal v-show="show_remove_ineligible_tenants_modal" @close="show_remove_ineligible_tenants_modal = false">
        <template slot="header">
            <span class="warning-text"><i class="material-icons">warning</i></span>
            <strong class="ml-2">Warning</strong>
        </template>

        <template slot="content">
            Proceeding will automatically delete tenants who are not eligible for the Audit Letter Program. This action cannot be undone
            and should only be completed right before starting the ALP process (before sending the first Audit Letter).
            <p>Remove ineligible tenants?</p>
        </template>

        <template slot="footer">
            <div v-show="is_loading_letters" class="remove-ineligible-tenants-loader">
                <img src="../../assets/img/loading-black-32.gif" alt="loading" />
            </div>
            <div class="flex jc-fe">
                <button type="button" :disabled="is_loading_letters" @click="show_remove_ineligible_tenants_modal = false">No</button>
                <button type="button" :disabled="is_loading_letters" class="ml-3" @click="remove_ineligible_ledgers">Yes</button>
            </div>
        </template>
    </modal>

    <send-letter-warning-modal
        v-if="show_updated_tenants_warning_modal"
        :isInitialLetter="selected_letter_type === LETTER_TYPES.initial"
        @confirm="onConfirmTenantsUpdated"
        @cancel="onRejectTenantsUpdated">
    </send-letter-warning-modal>

    <send-letter-date-modal
        v-if="show_audit_letter_modal"
        @save="onUpdateAuditLetterDate"
        @close="show_audit_letter_modal = false">
    </send-letter-date-modal>

    <send-letter-date-modal
        v-if="show_reminder_letter_modal"
        @save="onUpdateReminderLetterDate"
        @close="show_reminder_letter_modal = false">
    </send-letter-date-modal>
</div>
</template>

<script>
import http from "@/http"
import store from "@/store"
import Vue from "vue"
import dayjs from "dayjs"
import { debounce } from "lodash"
import { sendLettersColumns } from "../../utilities/columns"
import { statesByAbbr } from "@/utilities/states"
import { objectToParams } from "@/utilities/form-data"

const LETTER_TYPES = {initial: "initial", reminder: "reminder", welcome: "welcome", sample: "sample"}

export default {
    name: "send-letters-page",

    data () {
        return {
            active_filter_index: 0,
            active_state_index: -1,
            active_state: null,
            active_tab: "facility",
            audit_letter_date: dayjs(),
            checked_tenants: [],
            data_info: null,
            download_initiated: false,
            reminder_letter_date: dayjs(),
            error_loading_tenants: "",
            filtered_tenants: [],
            findFacilityError: "",
            http_options: {
                baseURL: this.$http.defaults.baseURL,
                headers: {
                    "X-Authorization": store.state.token.token
                },
                transformResponse: [(raw) => {
                    try {
                        let data = JSON.parse(raw)

                        return data
                    } catch (error) {
                        console.warn(error)
                        return raw
                    }
                }]
            },
            is_loading_letters: false,
            is_loading_facility: false,
            is_loading_tenants: false,
            facility: null,
            filter_counts: null,
            last_row_count: 0,
            selected_letter_type: null,
            show_updated_tenants_warning_modal: false,
            show_audit_letter_modal: false,
            show_reminder_letter_modal: false,
            show_tenant_length_modal: false,
            show_remove_ineligible_tenants_modal: false,
            state_options: statesByAbbr,
            success_modal_data: {
                url: null,
                letter_type: null,
                show: false,
                tenant_count: null
            },
            tenants: [],
            LETTER_TYPES
        }
    },

    computed: {
        columns () {
            let columns = sendLettersColumns

            switch (this.active_tab) {
            case "state":
                const facilityNumber = {
                    name: "__slot:facility_number",
                    title: "Facility Number",
                    width: "150px"
                }

                columns = sendLettersColumns.slice(0, 2).concat([facilityNumber], sendLettersColumns.slice(2))
            }

            return columns
        },

        filter_options () {
            if (!this.filter_counts) {
                return []
            }

            return [
                {
                    key: "all",
                    label: "All",
                    badge: this.filter_counts.all
                },
                {
                    key: "initial_letter_ready",
                    label: "Audit Letter Ready",
                    badge: this.filter_counts.initial_letter_ready
                },
                {
                    key: "reminder_letter_ready",
                    label: "Reminder Letter Ready",
                    badge: this.filter_counts.reminder_letter_ready
                },
                {
                    key: "welcome_letter_ready",
                    label: "Welcome Letter Ready",
                    badge: this.filter_counts.welcome_letter_ready
                }
            ]
        },

        has_tagged_tenants () {
            const counts = this.filter_counts

            if (!counts) {
                return false
            }

            if (!counts.tagged_for_removal) {
                return false
            } else {
                return true
            }
        },

        table_api_params () {
            const params = {}

            for (const index in this.filter_options) {
                if (parseInt(index) === this.active_filter_index) {
                    params.filter = this.filter_options[index].key
                }
            }

            return params
        },

        table_api_url () {
            if (this.active_tab === "facility" && this.facility) {
                return `/api/facilities/${this.facility.id}/tenants-mailing`
            } else if (this.active_tab === "state" && this.active_state_index !== -1) {
                return `/api/facilities/state/${this.state_options[this.active_state_index].key}`
            } else {
                return null
            }
        },

        today () {
            const date = new Date()
            const month = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1
            const day = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate()

            return `${date.getFullYear()}-${month}-${day}`
        }
    },

    watch: {
        active_tab () {
            this.facility = null
            this.active_state_index = -1
            this.filter_counts = null

            if (this.$refs.tenants_table) {
                Vue.nextTick(() => {
                    this.$refs.tenants_table.normalizeFields()
                    this.$refs.tenants_table.resetData()
                })
            }
        },

        active_filter_index () {
            if (this.active_tab === "facility" && !this.facility) {
                return
            }

            if (this.active_tab === "state" && !this.active_state) {
                return
            }

            // reload on the next tick so the API params has a chance to update
            Vue.nextTick(() => {
                if (this.table_api_url) {
                    this.$refs.tenants_table.reload()
                }
            })
        },

        facility: {
            deep: true,
            handler () {
                if (this.facility) {
                    this.filter_counts = null
                    this.active_filter_index = 0

                    if (this.$refs.tenants_table) {
                        this.$refs.tenants_table.reload()
                    }
                }
            }
        }
    },

    created () {
        this.debouncedReloadTable = debounce(() => {
            Vue.nextTick(() => {
                if (this.table_api_url) {
                    this.$refs.tenants_table.reload()
                }
            })
        }, 400)
    },

    methods: {
        onChangeFacility (newFacility) {
            this.facility = Object.assign({}, newFacility)
        },

        onFindFacilityError (message) {
            this.is_loading_facility = false
            this.findFacilityError = message
        },

        async remove_ineligible_ledgers () {
            const facilityTenants = this.$refs.tenants_table.tableData
            if (!facilityTenants) {
                this.$modalManager.add({ state: "bad", header: "Failed", body: "You must select a facility first." })
                return
            }

            const ledgerIds = facilityTenants.map((t) => t.ledger_id)
            try {
                this.is_loading_letters = true
                const { data } = await http.post("/api/tenants/remove-uneligible-ledgers", objectToParams({
                    ledger_ids: ledgerIds.join(","),
                    software: this.facility.software,
                    facility_number: this.facility.facility_number
                }))
                if (!data.success) { throw new Error(data.error_message) }

                this.$refs.tenants_table.reload()
                this.$modalManager.add({ state: "good", header: "Success", body: `${data.tenants_removed} tenant(s) were ineligible and removed.` })
            } catch (ex) {
                let errorMessage = ex && ex.message ? ex.message : ex
                this.$modalManager.add({ state: "bad", header: "Failed", body: errorMessage })
            } finally {
                this.is_loading_letters = false
                this.show_remove_ineligible_tenants_modal = false
            }
        },

        async sync_ledger_statuses () {
            const facilityTenants = this.$refs.tenants_table.tableData
            if (!facilityTenants) {
                this.$modalManager.add({ state: "bad", header: "Failed", body: "You must select a facility first." })
                return
            }

            const ledgerIds = facilityTenants.map((t) => t.ledger_id)
            try {
                this.is_loading_letters = true
                const { data } = await http.post("/api/tenants/sync-ledger-statuses", objectToParams({
                    ledger_ids: ledgerIds.join(","),
                    software: this.facility.software,
                    facility_number: this.facility.facility_number
                }))
                if (!data.success) { throw new Error(data.error_message) }

                this.$refs.tenants_table.reload()
                this.$modalManager.add({ state: "good", header: "Success", body: "Successfully updated tenant statuses." })
            } catch (ex) {
                let errorMessage = ex && ex.message ? ex.message : ex
                this.$modalManager.add({ state: "bad", header: "Failed", body: errorMessage })
            } finally {
                this.is_loading_letters = false
            }
        },

        async getFilterCounts () {
            try {
                if (this.active_tab === "facility") {
                    const { data: counts } = await http(`/api/facilities/${this.facility.id}/tenant-mailing-counts`)

                    this.filter_counts = counts
                } else if (this.active_tab === "state") {
                    const activeState = this.state_options[this.active_state_index].key

                    const { data: counts } = await http(`/api/facilities/state/${activeState}/tenant-mailing-counts`)

                    this.filter_counts = counts
                }
            } catch (ex) {
                this.$modalManager.add({ state: "bad", header: "Error loading tenant counts", body: ex })
            }
        },

        /**
         * Update the state field when a state is picked from the list.
         *
         * @param int index Chose state option index
         */
        onChangeState (index) {
            this.active_state_index = index

            this.active_state = this.state_options[index].key
        },

        onTableLoadStart () {
            this.is_loading_tenants = true

            this.getFilterCounts()
        },

        /**
         * Get the loaded record count when the table successfully loads data.
         *
         * @param {object} data Server response data object
         */
        onTableLoadSuccess ({ data: { data: response } }) {
            this.last_row_count = response.data.length

            if (response.info) {
                this.data_info = response.info
            } else {
                this.data_info = null
            }
        },

        /**
         * Generate letters for all checked tenants. A download link will open in a new tab/window.
         *
         * @param string letterType Letter type
         */
        async generateLetters (letterType) {
            let apiPath = ""
            let params = {
                letter_type: letterType,
                audit_letter_date: this.audit_letter_date.format("YYYY-MM-DD"),
                reminder_letter_date: this.reminder_letter_date.format("YYYY-MM-DD")
            }

            switch (this.active_tab) {
            case "facility":
                apiPath = `/api/facilities/${this.facility.id}/generate-letters`
                break

            case "state":
                apiPath = `/api/facilities/state/${this.state_options[this.active_state_index].key}/generate-letters`
                break

            default:
                this.$modalManager.add({ state: "bad", header: "Error", body: "No active tab selected." })
                return
            }

            // if tenants are selected, concat their IDs for the request
            if (this.checked_tenants.length) {
                params.tenants = this.checked_tenants.join(",")
            } else {
                const confirmed = confirm("The system will generate letters for the first 300 tenants. Continue?")

                if (!confirmed) {
                    return
                }
            }

            this.is_loading_letters = true

            const accountName = this.facility.account_name.replace(/[^ 0-9a-z\-.]/i, "")
            const outputName = `${this.facility.facility_number} - ${accountName}`

            try {
                const { data: response } = await http(apiPath, { params })

                const base = `${window.location.protocol}//${window.location.hostname}`
                const url = `${base}/api/facilities/download-letters/${response.file_name}?output_name=${outputName}`
                const mailMergeUrl = `${base}/api/facilities/download-letters/${response.mail_merge_file_name}?output_name=${outputName}`

                this.download_initiated = true
                this.success_modal_data = {
                    url: url,
                    mail_merge_url: (response.mail_merge_file_name) ? mailMergeUrl : null,
                    letter_type: response.letter_type,
                    show: true,
                    tenant_count: response.tenant_count
                }

                window.open(url, "_blank")
                if (response.mail_merge_file_name) {
                    window.open(mailMergeUrl, "_blank")
                }

                // deselect all checked tenants
                this.checked_tenants = []

                // update the tenants list
                this.getFilterCounts()
                this.$refs.tenants_table.reload()
            } catch (ex) {
                this.$modalManager.add({ state: "bad", header: "Error", body: ex })
            } finally {
                this.is_loading_letters = false
            }
        },

        /**
         * Generate sample letters for a single facility.
         */
        async generateSampleLetters () {
            let apiPath = `/api/facilities/${this.facility.id}/generate-sample-letters`

            this.is_loading_letters = true

            const accountName = this.facility.account_name.replace(/[^ 0-9a-z\-.]/i, "")
            const outputName = `${this.facility.facility_number} - ${accountName} - Sample`

            try {
                const { data: response } = await http(apiPath)

                const url = `${http.defaults.baseURL}/api/facilities/download-letters/${response.file_name}?output_name=${outputName}`
                const mailMergeUrl = `${http.defaults.baseURL}/api/facilities/download-letters/${response.mail_merge_file_name}?output_name=${outputName}`

                this.download_initiated = true
                this.success_modal_data = {
                    url: url,
                    mail_merge_url: (response.mail_merge_file_name) ? mailMergeUrl : null,
                    letter_type: "sample",
                    show: true,
                    tenant_count: 1
                }
            } catch (ex) {
                this.$modalManager.add({ state: "bad", header: "Error", body: ex })
            } finally {
                this.is_loading_letters = false
            }
        },

        /**
         * Initiate generating and downloading Initial letters.
         */
        onDownloadInitialLetters () {
            const targetTenants = this.filtered_tenants.filter(tenant => this.checked_tenants.indexOf(tenant.id) !== -1)

            // if any tenants are marked as having already been sent an initial letter, ask the
            // user for confirmation before continuing
            if (targetTenants.filter(tenant => tenant.initial_letter_sent_date !== null).length !== 0) {
                const confirmation = confirm("One or more of the selected tenants have already been sent an audit letter. Continue?")

                if (confirmation === false) {
                    return
                }
            }

            this.generateLetters(LETTER_TYPES.initial, targetTenants)
        },

        /**
         * Reload the table, causing it query the server for more data.
         */
        reloadTable () {
            this.$refs.tenants_table.reload()
        },

        /**
         * Change the pagination page when requested.
         *
         * @param object page Page
         *
         * @return null
         */
        onChangePage (page) {
            this.$refs.tenants_table.changePage(page)
        },

        /**
         * Toggle the state of the facility's checkbox for whichever row was clicked.
         *
         * @param object data  Row data object
         * @param object field Table field configuration
         * @param Event  ev    Event object
         */
        onRowClicked (data, field, ev) {
            this.toggleCheckbox(data.id)
        },

        /**
         * Update the pagination component when data is received.
         *
         * @param object paginationData Pagination data
         *
         * @return null
         */
        onPaginationData (paginationData) {
            this.$refs.tenants_table_pagination.setPaginationData(paginationData)
            this.$refs.tenants_table_info.setPaginationData(paginationData)
        },

        displayLetterWarningModal (letterType) {
            this.selected_letter_type = letterType
            this.show_updated_tenants_warning_modal = true
        },

        onConfirmTenantsUpdated () {
            this.show_updated_tenants_warning_modal = false
            // Only the first branch can currently be executed until we add tenant status automation functionality
            if (this.selected_letter_type === LETTER_TYPES.initial) {
                this.show_audit_letter_modal = true
            } else if (this.selected_letter_type === LETTER_TYPES.reminder) {
                this.show_reminder_letter_modal = true
            } else if (this.selected_letter_type === LETTER_TYPES.welcome) {
                this.generateLetters(LETTER_TYPES.welcome)
            }
        },

        onRejectTenantsUpdated () {
            this.selected_letter_type = null
            this.show_updated_tenants_warning_modal = false
        },

        onUpdateAuditLetterDate (date) {
            this.audit_letter_date = dayjs(date)

            this.show_audit_letter_modal = false

            this.generateLetters(LETTER_TYPES.initial)
        },

        onUpdateReminderLetterDate (date) {
            this.reminder_letter_date = dayjs(date)

            this.show_reminder_letter_modal = false

            this.generateLetters(LETTER_TYPES.reminder)
        },

        /**
         * Toggle the state of a facility's checkbox.
         *
         * @param int id Facility ID
         */
        toggleCheckbox (id) {
            if (this.checked_tenants.indexOf(id) === -1) {
                if (this.checked_tenants.length >= 300) {
                    this.show_tenant_length_modal = true
                } else {
                    this.checked_tenants.push(id)
                }
            } else {
                this.checked_tenants = this.checked_tenants.filter(checkId => checkId !== id)
            }
        }
    }
}
</script>

<style scoped>
.row-name {
    overflow: hidden;
    text-overflow: ellipsis;
}

.remove-ineligible-tenants-loader {
    float: left;
}
</style>



// WEBPACK FOOTER //
// src/pages/monitor/SendLettersPage.vue